export default function Breadcrumb() {
  return {}
}
